import { render, staticRenderFns } from "./menuH5.vue?vue&type=template&id=5c76678c&scoped=true"
import script from "./menuH5.vue?vue&type=script&lang=js"
export * from "./menuH5.vue?vue&type=script&lang=js"
import style0 from "./menuH5.vue?vue&type=style&index=0&id=5c76678c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c76678c",
  null
  
)

export default component.exports